export const checkerPusherUpdate = (idAsyncJob, data, type) => {
  if (
    idAsyncJob &&
    data.resource_id &&
    idAsyncJob === data.resource_id &&
    data.type === type &&
    data.success
  ) {
    return true;
  }
  return false;
};
